module.exports = __webpack_public_path__ + "static/media/site-logo.37d12ea0.svg";